import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent} from '../dashboard/dashboard.component';
import { DatabaseComponent} from '../database/database.component';
import { LinksComponent} from '../links/links.component';
import { ProfileComponent} from '../profile/profile.component';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'database', component: DatabaseComponent },
  { path: 'links',  component: LinksComponent },
  { path: 'profile', component: ProfileComponent }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /workspace/chess.arska.org/chess/src/app/app-routing/app-routing.module.ts